import { ExpertDoc, Optional } from 'packages/types'
import { i18n } from 'builder/utils/i18n'
import { FormatType } from '../constants'

export const trDocFileContent = (document: Optional<ExpertDoc>, format: FormatType) => {
  // This filename created just in case if we change documents storage to something on our domain.
  // In production we store documents on S3 and we can't modify name, only backend can do it
  // using 'response-content-disposition' query param
  const trDocFileName = document?.title || i18n.t('builder.dashboard.untitled')

  let fileFormat = format
  if (fileFormat === 'tr_doc') {
    fileFormat = 'docx'
  } else if (fileFormat === 'tr_pdf') {
    fileFormat = 'pdf'
  }

  const file = document?.files?.find(file => {
    if (format === 'docx') {
      return file?.filename?.endsWith('docx') || file?.filename?.endsWith('doc')
    }

    return file?.filename?.endsWith(fileFormat)
  })

  const trDocFileURL = file?.url
  const trDocFileContentType = file?.content_type

  return {
    trDocFileURL,
    trDocFileContentType,
    trDocFileName,
  }
}
